<template>
  <div class="form-container">
    <h1><span>被害と生息</span>
	<span class="color">
		（{{ typeMapping[wildlifeData.type] }}）
	</span>
	</h1>
    <table v-if="wildlifeData" class="wildlife-list-detail-table">
      <tbody>
        <tr>
          <td class="title">受付番号</td>
          <td class="text">： {{ wildlifeData.no }}</td>
        </tr>
        <tr>
          <td class="title">利用者</td>
          <td class="text">： {{ wildlifeData.id }}
          {{ wildlifeData.nameKanji }}</td>
        </tr>
        <tr>
		  <td class="title">確認場所</td>
          <td class="text">： {{ wildlifeData.municipalities }}
          </td>
        </tr>
        <tr>
          <td class="title"></td>
          <td class="text">　 {{ wildlifeData.strAdd }}
          </td>
        </tr>
        <tr>
          <td class="title">日時</td>
          <td class="text">： {{
			formatDate(wildlifeData.damageDate) }}</td>
        </tr>

        <tr>
          <td class="title">獣種</td>
          <td class="text">： {{
			animalTypeMapping[wildlifeData.animalType] }}
		  </td>
		</tr>
		<tr>
          <td class="title">頭数</td>
          <td class="text">： {{
			headCountTypeMapping[wildlifeData.count] }}</td>
        </tr>

        <tr>
          <td class="title">性別</td>
          <td class="text">： {{
			genderTypeMapping[wildlifeData.sex] }}</td>
		</tr>
		<tr>
          <td class="title">幼成獣</td>
          <td class="text">： {{
			juvenileTypeMapping[wildlifeData.byAnimal] }}
		  </td>
        </tr>
      </tbody>

      <tbody v-if="isDamageType">
        <tr>
          <td class="title">被害面積(㎡)</td>
          <td class="text">： {{ wildlifeData.damageArea }}</td>
		</tr>
        <tr v-if="isDamageType">
          <td class="title">被害金額(円)</td>
          <td class="text">： {{ wildlifeData.damageAmount }}</td>
        </tr>
      </tbody>

      <tbody>
        <!-- 画像データ -->
        <tr>
          <td class="title">画像</td>
          <td>： 
                <img :src="wildlifeData.imageUrl" class="thumb"
				@click="imageUp(wildlifeData.imageUrl)" />
				　
                <img :src="wildlifeData.imageUrl1" class="thumb"
				@click="imageUp(wildlifeData.imageUrl1)" />
				　
                <img :src="wildlifeData.imageUrl2" class="thumb"
				@click="imageUp(wildlifeData.imageUrl2)" />
          </td>
        </tr>
        <tr>
          <td class="title">備考</td>
          <td class="text">： {{ wildlifeData.addNote }}</td>
        </tr>
        <tr>
          <td class="title">緯度</td>
          <td class="text">： {{ wildlifeData.locationLat || '不明' }}
          </td>
        </tr>
        <tr>
          <td class="title">経度</td>
          <td class="text">　 {{ wildlifeData.locationLon || '不明' }}
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else>データを読み込めませんでした</p>
    <div class="d-detail-button-group">
    <button @click="goBack" class="second">戻る</button>
    <button @click="editRecord" class="usual" :class="{ disabled: this.editButtonDisabeld }" v-bind:disabled="this.editButtonDisabeld">編集</button>
    </div>
  </div>
<!-- ポップアップ -->
	<div class="popup" v-if="popup_on">
    	<img :src="popup_src" @click="imageDown" class="big" />
    </div>
</template>

<script>
import "@/assets/styles/Wildlife-detail-table.css";
export default {
  data() {
    return {
      wildlifeData: {},
      directAdminAgency: '',
      section: '',
      editButtonDisabeld: true,
      isDamageType: false,
      isSightType: false,
	  popup_on: false,
	  popup_src: '',
      typeMapping: {
        "1": "被害",
        "2": "捕獲",
        "3": "目撃",
        "4": "痕跡",
        "5": "わな",
        "9": "その他"
      },
      headCountTypeMapping: {
        "1" : "1", 
        "2" : "2", 
        "3" : "3", 
        "4" : "4", 
        "5" : "5以上", 
        "6" : "不明"
      },
      animalTypeMapping: {
        "01": "イノシシ",
        "02": "ニホンジカ",
        "03": "クマ",
        "04": "サル",
        "05": "タヌキ",
        "06": "アナグマ",
        "07": "ハクビシン",
        "08": "アライグマ",
        "09": "ヌートリア",
        "10": "鳥類",
        "11": "その他"
      },
      juvenileTypeMapping: {
        "1" : "成獣", 
        "2" : "幼獣", 
        "3" : "幼獣と成獣", 
        "4" : "不明"
      },
      genderTypeMapping: {
        "1" : "オス",
        "2" : "メス",
        "3" : "オスとメス",
        "6" : "不明",
      }
    };
  },
  created() {
	try {
      if (this.$route.query.data)
      	this.wildlifeData =
      		JSON.parse(decodeURIComponent(this.$route.query.data))[0];
	} catch(e) {
		alert(e);
	}
  },
  mounted() {
	try {
    console.log("Received wildlifeData:", this.wildlifeData);
    this.section = localStorage.getItem("section");
    this.directAdminAgency = localStorage.getItem("directAdminAgency");
    const userId = localStorage.getItem("userId");
  
    //「種別」が「被害」、「捕獲」、「目撃、痕跡」、その他」によって表示フラグを設定
    if (this.wildlifeData && this.wildlifeData.type === '1') {
      this.isDamageType = true;
    } else if (this.wildlifeData && this.wildlifeData.type === '2') {
      this.isSightType = true;
    }

    if (this.section === '0000') {
      // システム管理者は変更可能
      this.editButtonDisabeld = false;
    //} else if (this.section === '0100' || this.section === '0101' || this.section === '0210') {
    } else if (this.section === '0100' || this.section === '0101') {
      // 行政機関管理者、行政機関メンバーは変更可能
	  // 直属行政機関だけ職員が修正可能 2026/04/24 RFJ R.Komatsu
	  // 見える化管理者がメンバーのデータ修正するには再設計が必要
   	  if (this.wildlifeData.directAdminAgency == this.directAdminAgency)
      	this.editButtonDisabeld = false;
    } else {
      // それ以外は自分の登録されたデータだけが変更可能
      if (this.wildlifeData.id === userId) {
        this.editButtonDisabeld = false;
      }
    }
	} catch (e) {
		alert(e);
	}
  },
  methods: {
	imageDown() {
		this.popup_on = false;
	},
	imageUp(src) {
		if (this.popup_src != src) {
			this.popup_src = src;
			this.popup_on = true;
		} else {
			this.popup_on = !this.popup_on;
		}
	},
    formatDate(dateStr) {
      // UTC日時から日本時間に変換
      const date = new Date(dateStr);

      // 日付が無効な場合の処理
      if (isNaN(date.getTime())) {
        return '不明'; // 無効な日付の場合の表示
      }

      // JST (UTC + 9時間)に変換
      date.setHours(date.getHours() + 9);

      // フォーマット: yyyy年MM月dd日 hh:mm
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${year}年${month}月${day}日 ${hours}:${minutes}`;
    },
    goBack() {
      // ヒストリーに基づいて戻る
      this.$router.go(-1);

      // 状況に応じて、以下を補足的に入れることで確認可能
      const query = this.$route.query;
      console.log("Returning with query:", query);
    },
    editRecord() {
      this.$router.push({ name: 'DamageEdit', // 編集画面のルートパス
      query: { data: encodeURIComponent(JSON.stringify(this.wildlifeData)) }
      });
    }
  }
};
</script>

<style scoped>
.d-detail-button-group {
  display: flex;
  justify-content: center; /* ボタンを中央に配置 */
  margin-top: 20px; /* 上部余白を広げる */
}
.usual { background-color: #17a2b8; }
.first { background-color: #28a745; }
.alert { background-color: #ff6347; }
.second { background-color: #6c757d; }
.title { font-weight: bold; }
.color { color: green; }
.text { color: black; }
.thumb { max-width: 100px; cursor: zoom-in; }
.big { max-width: 300px; cursor: zoom-out; }
.popup {
  width:600px;
  height:auto;
  display: block;
  position: fixed;
  top: 15%;
  left: 70%;
  transform:translate(-50%);
  text-align: right;
}
</style>
